var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list-item',[_c('v-list-item-content',{staticStyle:{"font-weight":"300"}},[_vm._v(" "+_vm._s(_vm.field.DisplayName)+" ")]),_c('v-list-item-action',{staticStyle:{"font-weight":"300"}},[_c('v-btn',{attrs:{"plain":"","text":"","to":_vm.Record[_vm.field.Name]}},[_vm._v(_vm._s(_vm.Record[_vm.field.Name]))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }